<template>
  <div class="container bb-actions-panel-root">
    <!-- ------- -->
    <!-- ACTIONS -->
    <!-- ------- -->
    <div
      class="row d-flex justify-content-center rounded g-2 bb-actions-panel-section"
      :class="{ 'bb-panel-disabled': actionsDisabled }"
    >
      <span class="bb-hdg text-center bb-actions-panel-heading">Actions</span>
      <div
        v-for="actionDef in visibleActionCells"
        :key="actionDef.name"
        class="bb-actions-panel-cell"
      >
        <ToolTip
          v-if="!actionDef.placeholder"
          :text="actionDef.label"
          position="left"
        >
          <img
            :id="actionDef.name"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-action-panel-image"
            :src="getActionImg(actionDef.name)"
            @click="actionClick"
            :alt="actionDef.alt"
          />
        </ToolTip>
        <img
          v-else
          id="noImg"
          class="img-fluid rounded bb-img-norm-border bb-action-panel-image"
          :src="blankImg"
          alt="no action image"
        />
      </div>
    </div>
    <!-- -------------------------------------------- -->
    <!--                   REACTIONS                  -->
    <!-- -------------------------------------------- -->
    <div
      v-if="showReactionsPanel"
      :class="{ 'bb-panel-disabled': effectiveReactionsDisabled }"
      class="row d-flex justify-content-center rounded g-2 bb-actions-panel-section bb-actions-panel-section--reactions"
    >
      <span class="bb-hdg text-center bb-actions-panel-heading">Reactions</span>
      <!-- ------------------------------------------ -->
      <!-- 1. parry -->
      <div class="bb-actions-panel-cell">
        <ToolTip
          text="Parry"
          position="left"
        >
          <img
            id="parry"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-reaction-panel-image"
            :src="getReactionImg('parry')"
            @click="reactionClick"
            alt="parry image"
          />
        </ToolTip>
      </div>
      <!-- ------------------------------------------ -->
      <!-- 2. dodge -->
      <div class="bb-actions-panel-cell">
        <ToolTip
          text="Dodge"
          position="left"
        >
          <img
            id="dodge"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-reaction-panel-image"
            :src="getReactionImg('dodge')"
            @click="reactionClick"
            alt="dodge image"
          />
        </ToolTip>
      </div>
      <div class="w-100"></div>
      <!-- ------------------------------------------ -->
      <!-- 3. melee reaction -->
      <div class="bb-actions-panel-cell">
        <ToolTip
          text="Melee"
          position="left"
        >
          <img
            id="melee_reaction"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-reaction-panel-image"
            :src="getReactionImg('melee_reaction')"
            @click="reactionClick"
            alt="melee reaction image"
          />
        </ToolTip>
      </div>
      <!-- ------------------------------------------ -->
      <!-- 4. magic reaction -->
      <div class="bb-actions-panel-cell">
        <ToolTip
          text="Magic"
          position="left"
        >
          <img
            id="magic_reaction"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-reaction-panel-image"
            :src="getReactionImg('magic_reaction')"
            @click="reactionClick"
            alt="magic reaction image"
          />
        </ToolTip>
      </div>
      <div class="w-100"></div>
      <!-- ------------------------------------------ -->
      <!-- 5. special reaction -->
      <div class="bb-actions-panel-cell">
        <ToolTip
          text="Special Reaction"
          position="left"
        >
          <img
            id="special_reaction"
            class="img-fluid rounded bb-img-norm-border bb-hover bb-reaction-panel-image"
            :src="getReactionImg('special_reaction')"
            @click="reactionClick"
            alt="special reaction image"
          />
        </ToolTip>
      </div>
      <!-- ------------------------------------------ -->
      <!-- 6. filler -->
      <div class="bb-actions-panel-cell">
        <img
          id="noImg"
          class="img-fluid rounded bb-img-norm-border bb-action-panel-image"
          :src="blankImg"
          alt="no action image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'
import blankImg from '../assets/images/bbArena_PanelActionNoAction.png'
//==========================================================
// scripts
//---------
export default {
  name: 'ActionsPanel',
  components: {
    ToolTip,
  },
  watch: {
    disabled(newValue) {
      console.log('ActionsPanel disabled', newValue)
      if (newValue) {
        this.clearActionSelection()
      }
    },
    reactions_disabled(newValue) {
      console.log('ActionsPanel reactions_disabled', newValue)
      if (newValue) {
        this.clearReactionSelection()
      }
    },
    awaitingExtraAttacks(newValue) {
      if (newValue) {
        this.clearActionSelection()
        this.clearReactionSelection()
      }
    },
    arena_extra_action(newValue) {
      console.log('ActionsPanel arena_extra_action', newValue)
      if (newValue > 0) {
        this.clearActionSelection()
        this.clearReactionSelection()
      }
    },
  },
  //==========================================================
  // props
  //------
  props: {
    actions: {
      type: Array,
      required: true,
    },
    reactions: {
      type: Array,
      required: true,
    },
    arena_extra_action: {
      type: Number,
      required: true,
    },
    arena_extra_ready: {
      type: Boolean,
      default: false,
    },
    arena_round: {
      type: Number,
      required: true,
    },
    view_round: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reactions_disabled: {
      type: Boolean,
      default: false,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      toggleDesc: true,
      saveActionId: '',
      saveReactionId: '',
      blankImg,
      actionDefinitions: [
        { name: 'delay', label: 'Delay', alt: 'delay image' },
        { name: 'move', label: 'Move', alt: 'move image' },
        { name: 'change', label: 'Change', alt: 'change image' },
        { name: 'skill', label: 'Skill', alt: 'skill image' },
        { name: 'melee', label: 'Melee', alt: 'melee image' },
        { name: 'ranged', label: 'Ranged', alt: 'ranged image' },
        { name: 'reload', label: 'Reload', alt: 'reload image' },
        { name: 'aim', label: 'Aim', alt: 'target image' },
        { name: 'healing', label: 'Healing', alt: 'healing image' },
        {
          name: 'magic_action',
          label: 'Magic',
          alt: 'magic action image',
        },
        {
          name: 'remove_counter',
          label: 'Remove Counter',
          alt: 'counters image',
        },
        {
          name: 'special_action',
          label: 'Special Action',
          alt: 'special action image',
        },
        { name: 'no_action', label: 'No Action', alt: 'no action image' },
      ],
    }
  },
  //==========================================================
  // computed
  //---------
  computed: {
    future_round() {
      if (this.view_round > this.arena_round) {
        return true
      } else {
        return false
      }
    },
    awaitingExtraAttacks() {
      return this.arena_extra_ready
    },
    hideNonExtraActions() {
      if (this.arena_extra_action > 0 && !this.awaitingExtraAttacks) {
        return true
      } else {
        return false
      }
    },
    actionsDisabled() {
      return this.awaitingExtraAttacks ? false : this.disabled
    },
    effectiveReactionsDisabled() {
      return this.awaitingExtraAttacks || this.reactions_disabled
    },
    showReactionsPanel() {
      return !this.future_round && !this.awaitingExtraAttacks
    },
    visibleActions() {
      return this.actionDefinitions.filter((actionDef) =>
        this.isActionVisible(actionDef.name),
      )
    },
    visibleActionCells() {
      if (this.visibleActions.length % 2 == 0) {
        return this.visibleActions
      }

      return [
        ...this.visibleActions,
        {
          name: 'blank_action_cell',
          placeholder: true,
        },
      ]
    },
  },
  //==========================================================
  // methods
  //---------
  methods: {
    clearActionSelection() {
      if (this.saveActionId) {
        const action = document.getElementById(this.saveActionId)

        if (action) {
          action.style.borderColor = '#c2ccd6'
          action.style.borderWidth = '0.5px'
          action.style.opacity = '0.4'
        }
      }

      this.saveActionId = ''
      this.changeSlotsOpacity({
        reset: true,
        slot_array: this.actions,
        resetOpacity: '0.4',
      })
      this.emitter.emit('panel-action-selected', '')
    },
    clearReactionSelection() {
      if (this.saveReactionId) {
        const reaction = document.getElementById(this.saveReactionId)

        if (reaction) {
          reaction.style.borderColor = '#c2ccd6'
          reaction.style.borderWidth = '0.5px'
          reaction.style.opacity = '0.4'
        }
      }

      this.saveReactionId = ''
      this.changeSlotsOpacity({
        reset: true,
        slot_array: this.reactions,
        resetOpacity: '0.4',
      })
      this.emitter.emit('panel-reaction-selected', '')
    },
    //================================================
    // hide action
    //-------------
    isActionVisible(id) {
      if (this.awaitingExtraAttacks) {
        return id === 'move'
      }

      // in extra attack mode
      if (this.hideNonExtraActions) {
        let action = this.actions.find((a) => a.name == id)
        if (!action.extra) {
          return false
        }
        // future round
      } else if (this.future_round) {
        let action = this.actions.find((a) => a.name == id)
        if (!action.future) {
          return false
        }
      }
      return true
    },
    //================================================
    // get action image
    //------------------
    getActionImg(name) {
      let action = this.actions.find((a) => a.name == name)
      return action.image
    },
    //================================================
    // get reaction image
    //--------------------
    getReactionImg(name) {
      let reaction = this.reactions.find((a) => a.name == name)
      return reaction.image
    },
    //================================================
    // action click
    //--------------
    actionClick(e) {
      if (this.actionsDisabled) {
        return
      }

      let id = e.target.id // action name
      var action = document.getElementById(id)

      if (!action) {
        return
      }

      //-------------------------------
      // reset if click on same action
      //-------------------------------
      if (id == this.saveActionId) {
        action.style.borderColor = '#c2ccd6'
        action.style.borderWidth = '0.5px'
        action.style.opacity = '0.4'
        this.saveActionId = ''
        let parm = {
          reset: true,
          slot_array: this.actions,
          resetOpacity: '0.4',
        }
        //-----------------------
        // change slots capacity
        //-----------------------
        this.changeSlotsOpacity(parm)
        //----------------------
        // different id clicked
        //----------------------
      } else {
        //----------------------
        // highlight new action
        //----------------------
        action.style.borderColor = 'white'
        action.style.borderWidth = '3px'
        action.style.opacity = '1.0'
        //-------------------
        // reset save action
        //-------------------
        if (this.saveActionId != '') {
          var action_save = document.getElementById(this.saveActionId)

          if (action_save) {
            action_save.style.borderColor = '#c2ccd6'
            action_save.style.borderWidth = '0.5px'
            action_save.style.opacity = '0.4'
          }
        }
        //-----------------
        // save clicked id
        //-----------------
        this.saveActionId = id
        //-------------------
        // set slots opacity
        //-------------------
        let parm = {
          id: id,
          slot_array: this.actions,
        }
        this.changeSlotsOpacity(parm)
      }
      //----------------------
      // send selected action
      //----------------------
      this.emitter.emit('panel-action-selected', this.saveActionId)
    },
    //================================================
    // reaction click
    //----------------
    reactionClick(e) {
      if (this.reactions_disabled) {
        return
      }

      let id = e.target.id
      var reaction = document.getElementById(id)

      if (!reaction) {
        return
      }

      //---------------------------------
      // reset if click on same reaction
      //---------------------------------
      if (id == this.saveReactionId) {
        reaction.style.borderColor = '#c2ccd6'
        reaction.style.borderWidth = '0.5px'
        reaction.style.opacity = '0.4'
        this.saveReactionId = ''
        let parm = {
          reset: true,
          slot_array: this.reactions,
          resetOpacity: '0.4',
        }
        //-----------------------
        // change slots capacity
        //-----------------------
        this.changeSlotsOpacity(parm)
        //----------------------
        // different id clicked
        //----------------------
      } else {
        //------------------------
        // highlight new reaction
        //------------------------
        reaction.style.borderColor = 'white'
        reaction.style.borderWidth = '3px'
        reaction.style.opacity = '1.0'
        //---------------------
        // reset save reaction
        //---------------------
        if (this.saveReactionId != '') {
          var reaction_save = document.getElementById(this.saveReactionId)

          if (reaction_save) {
            reaction_save.style.borderColor = '#c2ccd6'
            reaction_save.style.borderWidth = '0.5px'
            reaction_save.style.opacity = '0.4'
          }
        }
        //-----------------
        // save clicked id
        //-----------------
        this.saveReactionId = id
        //-------------------
        // set slots opacity
        //-------------------
        let parm = {
          id: id,
          slot_array: this.reactions,
        }
        this.changeSlotsOpacity(parm)
      }
      //------------------------
      // send selected reaction
      //------------------------
      this.emitter.emit('panel-reaction-selected', this.saveReactionId)
    },
    //================================================
    // change slots opacity
    //----------------------
    changeSlotsOpacity(parm) {
      for (let i = 0; i < parm.slot_array.length; i++) {
        var slot = document.getElementById(parm.slot_array[i].name)
        if (!slot) {
          continue
        }
        if (parm.reset) {
          slot.style.opacity = parm.resetOpacity ?? '1.0'
        } else if (parm.slot_array[i].name == parm.id) {
          slot.style.opacity = parm.selectedOpacity ?? '1.0'
        } else {
          slot.style.opacity = parm.unselectedOpacity ?? '0.4'
        }
      }
    },
  },
  //==========================================================
  // mounted
  //--------
  mounted() {
    //========================================================
    // reset actions
    //---------------
    this.emitter.on('reset-panel-actions', (selected_action) => {
      var action = document.getElementById(selected_action.name)

      if (!action) {
        this.saveActionId = ''
        return
      }

      //-----------------------
      // reset selected action
      //-----------------------
      action.style.borderColor = '#c2ccd6'
      action.style.borderWidth = '0.5px'
      this.saveActionId = ''
      let parm = {
        reset: true,
        slot_array: this.actions,
        resetOpacity: '0.4',
      }
      //-----------------------
      // change slots capacity
      //-----------------------
      this.changeSlotsOpacity(parm)
    })
    //========================================================
    // reset reactions
    //-----------------
    this.emitter.on('reset-panel-reactions', (selected_reaction) => {
      if (!selected_reaction?.name) {
        this.saveReactionId = ''
        return
      }

      const reaction = document.getElementById(selected_reaction.name)

      if (reaction) {
        reaction.style.borderColor = '#c2ccd6'
        reaction.style.borderWidth = '0.5px'
        reaction.style.opacity = '0.4'
      }

      this.saveReactionId = ''
      this.changeSlotsOpacity({
        reset: true,
        slot_array: this.reactions,
        resetOpacity: '0.4',
      })
    })

    if (this.disabled) {
      this.clearActionSelection()
    }

    if (this.effectiveReactionsDisabled) {
      this.clearReactionSelection()
    }
  },
}
</script>

<style>
.bb-actions-panel-section {
  display: flex !important;
  flex-wrap: wrap !important;
  align-content: flex-start;
  align-items: start;
  justify-content: center;
  column-gap: 0.4rem;
  row-gap: 0.2rem;
  --bs-gutter-x: 0 !important;
  --bs-gutter-y: 0 !important;
}

.bb-actions-panel-section--reactions {
  margin-top: 1.9rem !important;
}

.bb-actions-panel-root {
  width: 100%;
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.bb-actions-panel-heading {
  display: block;
  flex: 0 0 100%;
  width: 100%;
  line-height: 1;
  margin: 0 0 0.9rem;
}

.bb-actions-panel-cell {
  flex: 0 0 88px;
  max-width: 88px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 94px;
  padding: 0 !important;
}

.bb-actions-panel-cell .tooltip-wrapper {
  display: block;
  line-height: 0;
}

#noImg {
  visibility: hidden;
}
.slotBtn:disabled {
  pointer-events: none;
  opacity: 0.1;
}
.bb-panel-disabled {
  opacity: 0.35;
  filter: grayscale(1);
  pointer-events: none;
}
.bb-action-panel-image {
  opacity: 0.4;
  display: block;
  width: 86px;
  height: 86px;
  object-fit: contain;
}
.bb-reaction-panel-image {
  opacity: 0.4;
  display: block;
  width: 86px;
  height: 86px;
  object-fit: contain;
}
</style>
